export const RESET_STORE_ACTION = 'RESET_STORE_ACTION';
